export default "__VITE_ASSET__576c7b6e__"